import { graphql } from "~/gql";

export const UPDATE_WORK = graphql(/* GraphQL */ `
  mutation updateWork($workId: Float!, $data: WorkUpdateInput!) {
    updateWork(workId: $workId, data: $data) {
      ...WorkParts
    }
  }
`);
